import React from 'react';
import './ProcessStep.css';



const ProcessStep = ({step}) => {

  // Destructuring props
  const { id, icon, image, title, content } = step;

  return (

    <div className='process-item' key={id}>

      <img src={image} alt={title} /> {/* Step Image */}

      <div className='content'>
        <div className='icon'>{icon}</div> {/* Step Icon */}
        <h6>0{id}</h6> {/* Step Number */}
        <h3>{title}</h3> {/* Step Title */}
        <p>{content}</p> {/* Step Content */}
      </div>

    </div>

  );
};

export default ProcessStep;